import { render, staticRenderFns } from "./unit-parameters.vue?vue&type=template&id=e1bfa968&scoped=true&"
import script from "./unit-parameters.vue?vue&type=script&lang=js&"
export * from "./unit-parameters.vue?vue&type=script&lang=js&"
import style0 from "./unit-parameters.vue?vue&type=style&index=0&id=e1bfa968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1bfa968",
  null
  
)

export default component.exports